import { TableCellValue } from '@nagel-types';

export const isEmptyCellValue = (value: TableCellValue | undefined) =>
    Array.isArray(value) ? value.length === 0 : !value;

export const toCellText = (value: TableCellValue | undefined) =>
    Array.isArray(value) ? value.join(', ') : value;
